import React, { useEffect, useState } from 'react'

import qs from 'qs'
import { connect } from 'react-redux'

import { Box, ProgressBar } from 'app/components/design-system-components'
import { ModalButtonGroup } from 'app/components/display/display'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import * as snugNotifier from 'app/services/snugNotifier'
import { history } from 'app/shared_components/router'
import { urlTo } from 'app/sm/helpers'
import {
  getCurrentStepForQuickStart,
  postNewStepForAgencyForQuickstart,
} from 'app/sm/team_viewing_preference/setup/api'
import * as setupHelpers from 'app/sm/team_viewing_preference/setup/helpers'
import { StyledSetupContainerSteps } from 'app/sm/team_viewing_preference/setup/index'
import TeamMembersTabs from 'app/sm/team_viewing_preference/teamMembers'
import { useLoadingStates } from 'app/utils/hooks/useLoadingStates'
import { isUserAnAdmin } from 'app/utils/roles'

const THIS_STEP = setupHelpers.SETUP_TEAM_MEMBERS

function TeamMembers({ match, currentAgency }) {
  const { loadingStatesHelpers: loadingStateHelpers } = useLoadingStates()

  const { params } = match
  const { teamSlug = '' } = params
  const curQueries = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  })
  const { teamGUID = '' } = curQueries

  const [wizardGUID, setWizardGUID] = useState('')
  const [currentStep, setCurrentStep] = useState(THIS_STEP)

  const isAdmin = currentAgency && isUserAnAdmin(currentAgency)

  useEffect(() => {
    getCurrentStepForQuickStart(teamGUID)
      .then((data) => {
        const { id, current_step_id } = data
        setWizardGUID(id)
        setCurrentStep(current_step_id)
      })
      .catch((error) => loadingStateHelpers.setError(error))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const goToNextStep = () => {
    history.push(urlTo('stepBranding', { teamSlug, agencyGUID: teamGUID }))
  }

  const onNextClicked = () => {
    if (currentStep === THIS_STEP) {
      postNewStepForAgencyForQuickstart(teamGUID, wizardGUID)
        .then(({ current_step }) => {
          const { ID } = current_step
          const step = setupHelpers.findWhichStepToRouteTo(ID)
          history.push(urlTo(step, { teamSlug, agencyGUID: teamGUID }))
        })
        .catch((error) => snugNotifier.error(error.message))
    } else {
      goToNextStep()
    }
  }

  if (!isAdmin) {
    history.push(
      urlTo('teamViewingPreferenceSetup', {
        teamSlug,
      }),
    )
  }

  return (
    <StyledSetupContainerSteps>
      <Box mb={theme.space[8] + 'px'}>
        <ProgressBar totalStepsCount={3} lastCheckedStep={2} />
      </Box>

      <TeamMembersTabs
        teamGUID={teamGUID}
        isAdmin={isAdmin}
        hideSuggestedMembers={false}
      />

      <ModalButtonGroup
        primaryLabel="Next"
        secondaryLabel="Back"
        secondaryButtonType="tertiary"
        primaryAction={onNextClicked}
        secondaryAction={() =>
          history.push(
            urlTo('stepLetsGetStarted', {
              teamSlug,
              agencyGUID: teamGUID,
            }),
          )
        }
        justifyContent="left"
      />
    </StyledSetupContainerSteps>
  )
}

const mapStateToProps = ({ session }) => ({
  teams: session.teams,
  currentAgency: session.currentAgency,
  currentUser: session.currentUser,
})

export default connect(mapStateToProps, null)(TeamMembers)
